import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tab', 'pane', 'autogrow']

  open(event) {
    this.tabTargets.forEach((tab) => {
      tab.removeAttribute('data-open')
    })
    this.paneTargets.forEach((pane) => {
      pane.removeAttribute('data-open')
    })

    event.target.setAttribute('data-open', '')
    const pane = event.target.dataset.pane
    document.getElementById(pane).setAttribute('data-open', '')

    this._autogrow()
    setTimeout(() => {
      this._autogrow()
    }, 10)
  }

  _autogrow() {
    this.autogrowTargets.forEach((autogrow) => {
      autogrow.style.height = 'auto'
      autogrow.style.height = `${autogrow.scrollHeight}px`
    })
  }
}
